import React, { useRef, useCallback, useState } from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import CircleProgress from '../../../../Components/Progress/Circle/CircleProgress';
import ControlledComboboxInput from '../../../../Components/Controlled/ControlledComboboxInput';
import BaseButton from '../../../../Components/Buttons/BaseButton';
import Recaptcha from '../../../../Components/Captcha/TurnstileManagedCaptcha';
import SimpleDivider from '../../../../Components/Dividers/SimpleDivider';
import ContractCard from '../../../../Components/Cards/ContractCard';
import InvoiceHelpDialog from '../../../../Components/Dialogs/InvoiceHelpDialog/InvoiceHelpDialog';
import QuestionMark from '../../../../Components/Adornments/QuestionMark';
import ErrorState from '../../../../Components/EmptyState/ErrorState';

import { HELP_TEXT } from '../../../../Utils/enums';
import { Company } from '../../../../Configs/general';
import { InvoiceHelpType } from '../../../../Enums/invoices';

const UserWithContract = props => {
  const {
    clickHandler,
    contract,
    errors,
    loading,
    control,
    inputChangeHandler,
    contractOptions,
    captchaRef,
    captchaHandlers,
    disableSubmit,
    contractSearched,
    authenticated
  } = props;

  const classes = useStyles();

  const DEFAULT_SEARCH_VALUE = { id: '', label: '' };

  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const inputRef = useRef(null);

  const onHelpClick = useCallback(() => {
    setHelpDialogOpen(true);
  }, []);

  return (
    <>
      <InvoiceHelpDialog
        open={helpDialogOpen}
        type={InvoiceHelpType.Contract}
        onClose={() => setHelpDialogOpen(false)}
        title={HELP_TEXT.contract}
      />
      <Grid item sm={5} xs={12} className={classes.inputContainerItem}>
        <ControlledComboboxInput
          id="Pqr_search_contract"
          name="contract"
          control={control}
          options={contractOptions}
          defaultValue={DEFAULT_SEARCH_VALUE}
          getOptionLabel={option => String(option.id)}
          renderOption={option => (
            <div className={classes.optionItemContainer}>
              {option.id}
              <span className={classes.optionItemAlias}>{option.label}</span>
            </div>
          )}
          onInputChange={inputChangeHandler}
          disabled={loading}
          TextInputProps={{
            label: `Número de ${Company.contractConjugation.regular.singular.main}`,
            type: 'number',
            InputProps: {
              endAdornment: (
                <InputAdornment
                  position="end"
                  classes={{ positionEnd: classes.positionEnd }}
                >
                  {loading && <CircleProgress />}
                  {!loading && <QuestionMark onClick={onHelpClick} />}
                </InputAdornment>
              )
            },
            error: Boolean(errors.contract),
            helperText:
              (errors.contract && errors.contract.message) ||
              (errors.contract &&
                errors.contract.id &&
                errors.contract.id.message)
          }}
        />
      </Grid>
      <Grid
        item
        sm={4}
        xs={12}
        ref={inputRef}
        className={classes.recaptchaContainer}
      >
        <Recaptcha
          captchaRef={captchaRef}
          referenceEl={inputRef}
          heightScale={0.9}
          locale="es"
          onResolved={captchaHandlers.onResolved}
          onExpired={captchaHandlers.onExpired}
          onError={captchaHandlers.onError}
          onLoaded={captchaHandlers.onLoaded}
        />
      </Grid>
      <Grid item sm={3} xs={12} className={classes.buttonContainer}>
        <BaseButton
          color="primary"
          variant="outlined"
          className={classes.button}
          onClick={clickHandler}
          disabled={disableSubmit}
          fullWidth
        >
          Consultar
        </BaseButton>
      </Grid>
      {(contract || contractSearched) && (
        <Grid item xs={12} className={classes.contractContainer}>
          <SimpleDivider />
          {contract && (
            <ContractCard
              data={contract}
              className={classes.contractCard}
              loading={false}
              showName={authenticated}
              showStratum={authenticated}
            />
          )}
          {!contract && contractSearched && !loading && (
            <ErrorState
              messageTitle={`No se encontró ${Company.contractConjugation.regular.singular.article}`}
              className={classes.emptyState}
            />
          )}
        </Grid>
      )}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  inputContainerItem: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2)
    }
  },
  positionEnd: {
    marginRight: theme.spacing()
  },
  optionItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  optionItemAlias: {
    color: '#B8B8B8',
    fontSize: 12
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingTop: 15,
      marginTop: 0
    }
  },
  button: {
    minHeight: 58
  },
  recaptchaContainer: {
    padding: 0
  },
  contractCard: {
    width: '100%'
  },
  emptyState: {
    marginTop: 0,
    marginBottom: theme.spacing(2)
  },
  contractContainer: {
    minHeight: 0,
    height: 'fit-content',
    width: '100%',
    overflow: 'hidden'
  }
}));

export default UserWithContract;
